// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page .page__image-demo[data-v-b1993486] {\n  border-radius: 4px;\n  width: 260px;\n  border: 1px solid #DCDFE6;\n}", ""]);
// Exports
module.exports = exports;
